// extracted by mini-css-extract-plugin
module.exports = {"root":"DeleteBtn_root__2mL8C"};